module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-gif-bd0b2d1132948541911bd0b92d44684a.svg";